module.exports = __webpack_public_path__ + "static/service-section02-img-sp-9522bbadd2b55b909a173ba5f205b2a3.png";